module.exports = __webpack_public_path__ + "img/about-page1-img-1.ce5cb07b.jpg";